import { Component, ElementRef, Inject, Renderer2, AfterViewInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { IconComponent } from '@nagel-assests';
import { ERROR_SNACKBAR, INFO_SNACKBAR, SnackbarType, SUCCESS_SNACKBAR } from '@nagel-types';
import { WARNING_SNACKBAR } from 'libs/nagel-types/src/lib/snackbarTypes';
import { ClipboardModule } from '@angular/cdk/clipboard';

const MAX_SNACKBAR_ACTION__SAME_ROW_LENGTH = 10;

type SnackbarClassesConfigType = {
    snackbarContent: string;
    snackbarText: string;
    snackbarIcon: string;
    snackbarAction: string;
    snackbarCloseIcon: string;
}

@Component({
    selector: 'lib-snackbar',
    imports: [
        IconComponent,
        MatIconModule,
        ClipboardModule
    ],
    templateUrl: './snackbar.component.html',
    styleUrl: './snackbar.component.scss'
})
export class SnackbarComponent implements AfterViewInit {
    constructor(
      @Inject(MAT_SNACK_BAR_DATA) public data: {
        message: string,
        action: string,
        type: SnackbarType,
        persistent?: boolean } = { message: '', action: '', type: SUCCESS_SNACKBAR },
      private snackBarRef: MatSnackBarRef<SnackbarComponent>,
      private renderer: Renderer2,
      private el: ElementRef
    ) {}

    private iconsMap: {[key: string]: string} = {
        [SUCCESS_SNACKBAR]: 'check_mark_icon',
        [ERROR_SNACKBAR]: 'triangle-exclamation_icon',
        [INFO_SNACKBAR]: 'circle_info_icon',
        [WARNING_SNACKBAR]: 'warning_icon'
    };

    private snackbarThemeClassMap: {[key: string]: SnackbarClassesConfigType} = {
        [SUCCESS_SNACKBAR]: {
            snackbarContent: 'success-content',
            snackbarText: 'success-text',
            snackbarIcon: 'success-icon',
            snackbarAction: 'success-action',
            snackbarCloseIcon: 'success-close-icon'
        },
        [ERROR_SNACKBAR]: {
            snackbarContent: 'error-content',
            snackbarText: 'error-text',
            snackbarIcon: 'error-icon',
            snackbarAction: 'error-action',
            snackbarCloseIcon: 'error-close-icon'
        },
        [INFO_SNACKBAR]: {
            snackbarContent: 'info-content',
            snackbarText: 'info-text',
            snackbarIcon: 'info-icon',
            snackbarAction: 'info-action',
            snackbarCloseIcon: 'info-close-icon'
        },
        [WARNING_SNACKBAR]: {
            snackbarContent: 'warning-content',
            snackbarText: 'warning-text',
            snackbarIcon: 'warning-icon',
            snackbarAction: 'warning-action',
            snackbarCloseIcon: 'warning-close-icon'
        }
    };

    ngAfterViewInit() {
        if (this.el.nativeElement.closest('.mat-mdc-snackbar-surface')?.parentElement) {
            this.renderer.addClass(this.el.nativeElement.closest('.mat-mdc-snackbar-surface')?.parentElement, this.classes.snackbarContent);
        }
    }

    getIcon(type: SnackbarType) {
        return this.iconsMap[type];
    }

    getThemeClasses(type: SnackbarType): SnackbarClassesConfigType {
        return this.snackbarThemeClassMap[type as keyof typeof this.snackbarThemeClassMap] || {};
    }

    buttonClass = this.data.action.length > MAX_SNACKBAR_ACTION__SAME_ROW_LENGTH
        ? 'snackbar-action-long'
        : 'snackbar-action-short';

    classes = this.getThemeClasses(this.data.type);

    snackbarContentClass = `snackbar-content ${this.classes.snackbarContent}`;
    snackbarTextClass = `snackbar-text ${this.classes.snackbarText}`;
    snackbarIconClass = `snackbar-icon ${this.classes.snackbarIcon}`;
    snackbarActionClass = `${this.buttonClass} ${this.classes.snackbarAction}`;
    snackbarCloseIconClass = `${this.classes.snackbarCloseIcon}`;

    onActionClick() {
        //Logic for action click
    }

    getCopyButtonClass(): string {
        return `${this.buttonClass} ${this.classes.snackbarAction} mr-3 mb-[2px]`;
    }

    onClose() {
        this.snackBarRef.dismiss();
    }
}